export default "__VITE_ASSET__D1Yka5ZC__"